import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./SwiperStyles.css";

// import required modules
import { FreeMode, Pagination, Navigation } from "swiper/modules";
import SpecialItem from "../../Main/ListOfProducts/SpecialItem";

const SwiperListOfSpecialProductsLayout = ({
  data,
  navColor,
}: {
  data: any;
  navColor: string;
}) => {
  const breakpoints = {
    320: { slidesPerView: 1.1 },
    380: { slidesPerView: 1.2 },
    400: { slidesPerView: 1.3 },
    450: { slidesPerView: 1.4 },
    500: { slidesPerView: 1.5 },
    600: { slidesPerView: 1.7 },
    650: { slidesPerView: 1.9 },
    768: { slidesPerView: 2.2 },
    900: { slidesPerView: 2.8 },
    1080: { slidesPerView: 3.3 },
    1280: { slidesPerView: 3.8 },
    1360: { slidesPerView: 4.1 },
  };
  // console.log("navColor", navColor);

  return (
    <div
      style={
        {
          // Set navigation arrow color dynamically
          "--swiper-navigation-color": navColor || "red",
        } as React.CSSProperties
      }
    >
      <Swiper
        breakpoints={breakpoints}
        slidesPerView={1.1}
        spaceBetween={10}
        // navigation={true}
        freeMode={true}
        pagination={{
          // type: "fraction",
          clickable: true,
        }}
        // modules={[FreeMode, Pagination]}
        modules={[ Navigation]}
        className="mySwiper"
      >
        {data.map((product: any) => (
          <SwiperSlide>
            <SpecialItem
              key={product.id}
              items={product}
              colorCode={product.colorCode}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SwiperListOfSpecialProductsLayout;
